module.exports = __webpack_public_path__ + "static/media/8-6.cbed6e84.mp3";